<script>
import Engine from '../mixins/Engine'
import {toUnicode as punycodeToUnicode} from 'punycode-url';
import {nextTick} from "vue";
import Button from "primevue/button";
import {ArrayHelper} from "../helpers/ArrayHelper";
import {BaseEngineIcons} from "../constants/baseEngineIcons";
import AdaptersDropdown from "../component/adapters/Dropdown.vue";
import AdaptersAutoComplete from "../component/adapters/AutoComplete.vue";
import AdaptersLoader from "./adapters/Loader.vue";
import {FormatHelper} from "../helpers/FormatHelper";
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import DomainApi from "../api/DomainApi";

export default {
    name: "PromoSearchForm",
    props: {
        initialValue: {
            type: String,
            required: false
        },
        showHint: {
            type: Boolean,
            required: false,
            default: true
        },
        showDb: {
            type: Boolean,
            required: false,
            default: true
        },
        formAction: {
            type: String,
            required: false,
            default: 'report'
        },
        fieldName: {
            type: String,
            required: false,
            default: 'domain'
        },
        apiType: {
            type: String,
            required: false,
            default: 'domain_and_keyword'
        },
        placeholder: {
            type: String,
            required: false
        },
        useAutocomplete: {
            type: Boolean,
            required: false,
            default: true
        },
        isGroup: {
            type: Boolean,
            required: false,
            default: false
        },
        isYaDirect: {
            type: Boolean,
            required: false,
            default: false
        },
        isLinks: {
            type: Boolean,
            required: false,
            default: false
        },
        enableSelect: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    mixins: [Engine],
    data() {
        return {
            input_search: "",
            selectedSuggestionId: null,
            chooseDataBase: false,
            bases: (() => {
                return this.$tm('lang.main.bases');
            })(),
            suggestion: [],
            suggestionIds: {},
            engine: null,
            base: null,
            // кол-во символов, с которых идет запрос на подгрузку подсказок в поиске
            searchLengthLoadData: 4,
            // задержка при вводе в поисковую строку перед отправкой запроса
            searchDelayLoadData: 500,
            currentBase: this.getCurrentBase,
            allowSuggestion: true,
            focusSearch: false,
            hoverSearch: false,
            defaultImageChannel: '/i/project-image-not-found.webp',
            // ширина блока выбора региона
            regionWidth: 0,
        }
    },
    methods: {
        getZenChannel() {
            return this.selectedSuggestionId === null ? this.input_search : this.selectedSuggestionId
        },
        currentPlaceholder() {
            if (this.placeholder) {
                return this.placeholder;
            }

            return !this.isGroup
                ? (this.isZen() ? this.$t('lang.main.promo.zen_placeholder') : this.$t('lang.main.promo.placeholder'))
                : this.$t('lang.main.promo.placeholder_group');
        },
        doSearch(query) {
            this.input_search = query;
            this.selectedSuggestionId = query;

            this.doFilter();
        },
        paste(event) {
            event.preventDefault();
            let pasteText = event.clipboardData.getData('text');
            try {
                const url = new URL(event.clipboardData.getData('text'));
                pasteText = punycodeToUnicode(pasteText)
            } catch (e) {}
            this.input_search = pasteText

            this.doFilter();
        },
        submitForm() {
            let self = this;
            nextTick(() => {
                self.$refs.form.submit();
            });
        },
        doFilter() {
            if (!this.useAutocomplete) {
                return false;
            }

            if (this.input_search === "" || this.input_search.length < this.searchLengthLoadData || !this.allowSuggestion) {
                return false;
            }

            DomainApi
                .getSuggestion((this.isZen() ? 'zen' : this.apiType), {
                    query: encodeURIComponent(this.input_search),
                    base: this.getCurrentDatabaseName
                })
                .then(response => this.suggestion = response);
        },
        onChangeDatabase(e) {
            let database = e.value;
            database.dbname = database.name;
            database.sename = database.engine;
            this.$store.commit('SET_DATABASE', database);

            if (this.isZenEngine(database.engine)) {
                window.open('/' + window.locale + '/dzen', '_self');
            }
        },
        getEngineIcon(engine) {
            return BaseEngineIcons[engine];
        },
        itemSelect() {
            this.allowSuggestion = false;
            if (this.isZen()) {
                this.input_search = this.input_search.url;
            }
            this.submitForm();
        },
        beforeShow() {
            if (!this.allowSuggestion) {
                /**
                 * Необходимо т.к. событие @item-select происходит позже, чем @change.
                 * Запрещаем отображение подсказок при нажатии на подсказку.
                 */
                this.$refs.searchplace.hide();
            }
        },
        replaceImageChannelByDefault(e) {
            e.target.src = this.defaultImageChannel;
        },
        getCountSubscribes(count) {
            return FormatHelper.number(count);
        },
        checkChangeRegion() {
            let element = document.getElementById('promo_search_form__database_container');
            if (this.regionWidth !== element.clientWidth) {
                this.regionWidth = element.clientWidth
            }
        }
    },
    computed: {
        getApiUrl() {
            return sprintf(
                '%s/suggestion/%s?query=%s&base=%s',
                this.$config.API_URL,
                (this.isZen() ? 'zen' : this.apiType),
                encodeURIComponent(this.input_search),
                this.getCurrentDatabaseName
            );
        },
        getFormAction() {
            /**
             * Запросы, которые заканчиваются на слеш, редиректятся на uri без конечного слеша.
             * Это приводило к проблемам, когда POST запросы редиректились на этот же url, но браузер потом делал GET запрос.
             * Из-за этого как минимум не работали групповые отчёты.
             *
             * Поэтому слеша никогда не должно быть в конце
             */

            let formAction = this.formAction;

            if (this.isZen()) {
                formAction = 'dzen/report';
            }

            const parts = [];
            if (window.locale) parts.push(window.locale)
            if (formAction) parts.push(formAction)
            return (parts.length > 0 ? '/' + parts.join('/') : '')
                + (this.isLinks ? '#block-links' : '');
        },
        promoDomain() {
            const items = this.bases.filter(item => item.name === this.getCurrentDatabaseName);

            if (this.isYaDirect) {
                return this.$t(`lang.main.promo.ya_direct.domain`)
            }

            if (this.isLinks) {
                return  this.$t('lang.main.promo.links.domain');
            }

            if (this.isGoogleNY()) {
                return this.$t(`lang.main.promo.engine.gny.domain`);
            }

            return items.length > 0 ? this.$t(`lang.main.promo.engine.${items[0].engine}.domain`) : '';
        },
        promoKeyword() {
            const items = this.bases.filter(item => item.name === this.getCurrentDatabaseName);

            if (this.isYaDirect) {
                return this.$t(`lang.main.promo.ya_direct.keyword`)
            }

            if (this.isGoogleNY()) {
                return this.$t(`lang.main.promo.engine.gny.keyword`);
            }

            return items.length > 0 ? this.$t(`lang.main.promo.engine.${items[0].engine}.keyword`) : '';
        },
        getCurrentDatabase() {
            return this.$store.getters.DATABASE;
        },
        getCurrentDatabaseName() {
            return this.getCurrentDatabase.dbname
        },
        isLoadedDatabase() {
            return this.$store.getters.IS_LOADED_DATABASE;
        },
        getCurrentBase() {
            return ArrayHelper.getObjectByAttrValue(this.bases, 'name', this.getCurrentDatabase.dbname);
        },
        getPaddingRightInputSearch() {
            return (this.regionWidth + 17) + 'px';
        }
    },
    watch: {
        input_search(val) {
            if (val === "") {
                this.suggestion = [];
            }
        },
        getCurrentDatabase() {
            this.currentBase = this.getCurrentBase;
        }
    },
    updated() {
      this.checkChangeRegion();
    },
    mounted() {
        if (this.initialValue) {
            this.input_search = this.initialValue;
        }
    },
    components: {
        Button,
        AdaptersDropdown,
        AdaptersAutoComplete,
        AdaptersLoader,
        IconField,
        InputIcon,
    },
}
</script>
<template>
    <div class="promo-search-form">
        <form
            ref="form"
            :action="getFormAction"
            :autocomplete="useAutocomplete ? 'off' : 'on'"
            :method="isGroup ? 'POST' : 'GET'"
            @submit.prevent
        >
            <div class="card flex flex-column sm:flex-row w-full">
                <div class="flex flex-column w-full">
                    <div class="flex flex-1 relative">
                        <div class="w-full promo_search_form__search_container">
                            <span class="w-full">
                                <IconField iconPosition="left">
                                    <InputIcon class="pi pi-search" />
                                    <AdaptersAutoComplete
                                        v-model="input_search"
                                        :suggestions="suggestion"
                                        @change="doFilter"
                                        :placeholder="currentPlaceholder()"
                                        :minLength="searchLengthLoadData"
                                        class="w-full"
                                        inputClass="p-input-lg w-full"
                                        @keyup.enter="submitForm"
                                        @paste="paste"
                                        :delay="searchDelayLoadData"
                                        :name="isZen ? '' : fieldName"
                                        ref="searchplace"
                                        @item-select="itemSelect"
                                        @before-show="beforeShow"
                                        @focus="focusSearch = true"
                                        @blur="focusSearch = false"
                                        @mouseenter="hoverSearch = true"
                                        @mouseleave="hoverSearch = false"
                                        :pt="{
                                            item: ({ props, state, context }) => ({
                                                class: 'font-light'
                                            }),
                                            input: { style: 'padding-right: ' + getPaddingRightInputSearch },
                                            panel: { style: 'max-width: 1;' }
                                        }"
                                    >
                                        <template #option="{option}">
                                            <template v-if="isZen()">
                                                <div class="flex justify-content-between align-items-center">
                                                    <div class="flex align-items-center" style="max-width: 80%">
                                                        <img :alt="option.name" :src="option.logo" class="w-2rem h-2rem mr-2 border-circle" @error="replaceImageChannelByDefault" />
                                                        <span class="text-sm md:text-base overflow-hidden text-overflow-ellipsis" :title="option.name">{{ option.name }}</span>
                                                    </div>
                                                    <div class="hidden md:flex align-items-center" style="max-width: 20%;">
                                                        <i class="pi pi-users mr-1"></i> <span class="overflow-hidden text-overflow-ellipsis" :title="getCountSubscribes(option.subscribers)">{{ getCountSubscribes(option.subscribers) }}</span>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-else>
                                                {{ option }}
                                            </template>
                                        </template>
                                    </AdaptersAutoComplete>
                                </IconField>
                            </span>
                        </div>
                        <div
                            id="promo_search_form__database_container"
                            class="flex align-items-center absolute promo_search_form__database_container"
                            :class="{'promo_search_form__database_focus': (focusSearch || hoverSearch)}"
                        >
                            <div v-show="showDb && isLoadedDatabase">
                                <AdaptersDropdown
                                    v-model="currentBase"
                                    :options="bases"
                                    optionLabel="caption"
                                    @change="onChangeDatabase"
                                    filter
                                    :disabled="!enableSelect"
                                    class="promo_search_form__database"
                                    :resetFilterOnHide="true"
                                    :hoverUsage="true"
                                >
                                    <template #value="slotProps">
                                        <div v-if="slotProps.value" class="flex align-items-center">
                                            <img
                                                :alt="slotProps.value.caption"
                                                :src="getEngineIcon(slotProps.value.engine)"
                                                width="120"
                                                height="120"
                                            />
                                            <div>{{ slotProps.value.short }}</div>
                                            <i class="fa fa-caret-down"></i>
                                        </div>
                                        <span v-else>
                                            {{ slotProps.placeholder }}
                                        </span>
                                    </template>
                                    <template #filtericon>
                                        <i class="pi pi-search" />
                                    </template>
                                </AdaptersDropdown>
                            </div>
                        </div>
                    </div>
                    <div v-if="showHint" class="promo-search-form_bottom mt-2">
                        <div class="promo-search-form_links flex flex-wrap gap-1">
                            <template v-if="promoDomain || (!isLinks && promoKeyword)">
                                <span class="hint-link" @click.prevent="doSearch(promoDomain)">{{ promoDomain }}</span>
                                <template v-if="!isLinks">
                                    <span class="hint-divide">{{ $t('lang.main.promo.or') }}</span>
                                    <span class="hint-link" @click.prevent="doSearch(promoKeyword)">{{ promoKeyword }}</span>
                                </template>
                            </template>
                            <!-- просто для того, чтобы не прыгала вёрстка -->
                            <span v-else class="line-height-1">&nbsp;</span>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="flex ml-0 sm:ml-2 mt-2 sm:mt-0">
                       <Button :label="$t('lang.main.btn.search')" @click="submitForm" class="w-full sm:w-auto promo_search_form__button_search" size="large" />
                    </div>
                </div>
            </div>
            <input v-if="isZen" :name="fieldName" :value="getZenChannel()" type="hidden"/>
            <input v-if="!isYaDirect" :value="getCurrentDatabaseName" name="db" type="hidden" />
        </form>
    </div>
</template>

<style scoped>
.promo_search_form__search_container .p-input-icon {
    z-index: 1;
    font-size: 1.3rem;
    margin-top: -0.55rem;
    color: var(--gray-500);
}
.promo_search_form__search_container:deep(.p-autocomplete-input) {
    padding-left: 2.6rem;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 300;
}
.promo_search_form__search_container:deep(.p-autocomplete-input::placeholder) {
    color: var(--text-color-secondary);
}
.promo_search_form__database_container:deep(.p-dropdown-trigger) {
    display: none;
}
.promo_search_form__database_container {
    right: 4px;
    top: 4px;
}
.promo_search_form__database {
    border: 1px solid var(--gray-200);
    background-color: var(--gray-200);
}
.promo_search_form__database:not(.p-disabled).p-focus,
.promo_search_form__database:hover,
.promo_search_form__database:not(.p-disabled).p-focus:hover {
    border-color: var(--gray-200);
}
.promo_search_form__database div,
.promo_search_form__database .fa {
    color: var(--text-color-secondary);
}
.promo_search_form__database_container img {
    max-height: 1rem;
    width: auto;
    height: auto;
    border-radius: 50%;
    margin-right: 4px;
}
.promo_search_form__database_container i::before {
    position: static;
    margin-left: 0.5rem;
}
.promo_search_form__database_focus {
    border-color: var(--primary-color);
}
.sbmtbtn.bx-demo input {
    background: #00000033;
}
.sbmtbtn.bx-demo input:hover {
    background: #15aac0; text-shadow: 0 0 8px rgba(255,255,255,1);
}
.promo_search_form__button_search {
    padding-left: 50px;
    padding-right: 50px;
}
.promo-search-form_bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
